import { EDGE_TRANSITION_TYPES, NODE_TYPES } from '@/utils/state-tree.generator'
import store from '@/store/store'

class PreviewModule {

  isSaved = {
    get() {
      return store.state.ui.preview.isSaved
    },

    set(isSaved) {
      store.commit('UI_ANSWER_SET_IS_SAVED', isSaved)
    }
  }

  error = {
    get() {
      return store.state.ui.preview.error
    },
    set(error) {
      store.commit('UI_ANSWER_SET_ERROR', error)
    }
  }

  botEmailConfig = {
    get() {
      return store.state.ui.preview.emailTemplateConfig
    },

    set(emailConfig) {
      store.commit('UI_EMAIL_TEMPLATE_CONFIG_SET', emailConfig)
    }
  }

  isEmptyStateTree(stateTree) {
    return stateTree?.type === NODE_TYPES.EMPTY
  }

  errorDescription() {
    return store.state.ui.preview.error?.description || null
  }

  errorPath() {
    return store.state.ui.preview.error?.path || null
  }

  isAddingToEmptyPostback(node) {
    const error = store.state.ui.preview.error
    if (!error || !error.description.includes('Please add content')) return false

    if ([EDGE_TRANSITION_TYPES.POSTBACK, EDGE_TRANSITION_TYPES.QUICK_REPLY].includes(node?.parent?.transition.type)) {
      return node.parent.node.stateId === error.stateId &&
        node.parent.node.actionId === error.actionId
    }

    return node.stateId === error.nextStateId &&
      node.type === NODE_TYPES.EMPTY
  }

}

export default new PreviewModule()
